<script lang="ts">
	import type { PoiFilterId as PoiFilterIdType } from '../../types';
	import { getSearchParamsStore } from '$lib/services/urls/searchParams';
	import { createEventDispatcher } from 'svelte';
	import RangeSlider from '../../../atoms/range-slider/RangeSlider.svelte';

	export let min: number;
	export let max: number;
	export let id: PoiFilterIdType;
	export let defaultValue: number[];
	export let name: string;

	const searchParams = getSearchParamsStore(false);
	const dispatch = createEventDispatcher<{
		change: { id: PoiFilterIdType; value: (number | undefined)[] | undefined };
	}>();

	function getMultiSliderDefaultValue(): number[] {
		return ($searchParams.filters?.[id] ?? defaultValue) as number[];
	}

	function handleMultiSliderChange(value: number[]) {
		const noFilterApplied = value[0] === min && value[1] === max;
		const filterValue = [value[0], value[1] === max ? undefined : value[1]];

		dispatch('change', { id, value: noFilterApplied ? undefined : filterValue });
	}
</script>

<RangeSlider
	{min}
	{max}
	defaultValue={getMultiSliderDefaultValue()}
	getValueLabel={value => `${value[0]}`}
	label={name}
	onValueChange={range => handleMultiSliderChange(range)}
/>
